// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"785":"381b41dc","914":"8ebdcc0f"}[chunkId] + ".chunk.css";
};